import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import Icon from 'tfs.icon'

class InteractivePopUp extends Component {
  backDropRef = createRef()

  handleBackDropClick = clickEvent => {
    if (clickEvent.target === this.backDropRef.current) {
      this.props.closePopUp()
    }
  }
  handleCloseButtonClick = () => this.props.closePopUp()

  render() {
    const { classes, children, isPopUpOpen } = this.props

    if (!isPopUpOpen) {
      return null
    }

    return (
      <div
        data-element="backdrop-interactive-popup"
        ref={this.backDropRef}
        className={classes.backDrop}
        onClick={this.handleBackDropClick}
      >
        <div className={classes.wrapper}>
          <button
            data-element="close-button-interactive-popup"
            type="button"
            className={classes.closeButton}
            onClick={this.handleCloseButtonClick}
          >
            <Icon name="close" />
          </button>
          {children}
        </div>
      </div>
    )
  }
}

InteractivePopUp.propTypes = {
  children: PropTypes.node,
  isPopUpOpen: PropTypes.bool,
  closePopUp: PropTypes.func,
}

export default InteractivePopUp
